import { FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { makeAutoObservable } from 'mobx';
import { getEffectiveDatesOptions } from 'global/services-helpers/domainService';
import { getRootStoreInstance, RootStore } from 'store/rootStore';
import { OptionType } from '@insurancemenu/imenu-components-lib/dist/types/Select';

type InitiateQuoteBasicInfoFields = {
  proposalName: FormControl<string>;
  effectiveDate: FormControl<string>;
  zip: FormControl<string>;
  state: FormControl<string>;
  county: FormControl<string>;
};

export default class BasicInfoStepController {
  private readonly _rootStore: RootStore = getRootStoreInstance();

  public form: FormController<InitiateQuoteBasicInfoFields>;

  public get isValid(): boolean {
    return this.form.basicFieldsValidationsPassed && !this.form.isLoading;
  }

  public get effectiveDatesOptions(): OptionType[] {
    return getEffectiveDatesOptions(this._rootStore.domainStoreV2.effectiveDates);
  }

  constructor() {
    this.form = FormController.create(
      {
        proposalName: new FormControl<string>('', {
          validations: ['printableCharacters'],
        }),
        effectiveDate: new FormControl<string>(''),
      },
      {
        capabilities: [
          {
            type: 'zip',
            params: {
              state: {
                customValidations: [
                  {
                    check: this._rootStore.domainStoreV2.isEligibleState,
                    msg: 'State is ineligible',
                  },
                ],
              },
            },
          },
        ],
      },
    );

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
